import { User } from '@greenkub-fronts/shared/interface';
import { H1, H2, BtnLevel, Button, IconEnum, Icon, Avatar } from '../';
import { profiles } from '../../assets';
import styles from './error-boundary.module.scss';

interface ErrorBoundaryProps {
  user: User | undefined;
  role: string;
  navigate: Function;
  error: Error;
  currentLocation: string | undefined;
  buttonReturnHandler: Function;
  resetErrorBoundary: Function;
  setIsMoreDetails: Function;
  isMoreDetails: boolean;
}

export function ErrorBoundary(props: ErrorBoundaryProps) {
  const {
    user,
    role,
    error,
    currentLocation,
    buttonReturnHandler,
    resetErrorBoundary,
    setIsMoreDetails,
    isMoreDetails,
  } = props;

  return (
    <div className={styles['ErrorBoundary']}>
      <Icon name={IconEnum.ALERT} />
      <H1
        className={styles['buble-first']}
        bold={true}
        color={'black'}
        value={"Une erreur s'est produite !"}
      ></H1>
      {user === undefined || role !== 'GK' ? (
        <>
          <H1
            value={
              'Une erreur a été détectée. Veuillez retourner à la page précédente.'
            }
          />
        </>
      ) : (
        <>
          <div className={styles['SecondLine']}>
            <Avatar
              user={{
                email: 'jean.simondon@greenkub.fr',
                lastName: 'Simondon',
                firstName: 'jean',
              }}
            />
            {/* <img className={styles['Avatar']} src={img} alt="avatar" /> */}
            <H1
              bold={true}
              color={'black'}
              value={
                "Veuillez m'envoyer l'erreur détaillée en capture d'écran sur slack. Merci"
              }
            />
            <Icon name={IconEnum.THUMB_UP} />
          </div>

          <H2 color={'black'} value={`ERREUR : ${error?.message}`}></H2>
          <Button
            level={BtnLevel.PRIMARY}
            onClick={() => setIsMoreDetails(!isMoreDetails)}
          >
            {!isMoreDetails ? (
              <p>Afficher plus de détails</p>
            ) : (
              <p>Cacher les détails</p>
            )}
          </Button>
          {isMoreDetails && (
            <p
              style={{
                color: 'black',
                textAlign: 'left',
                whiteSpace: 'pre-wrap',
                lineHeight: '2.5rem',
                fontSize: '1.3rem',
              }}
            >
              {error.stack}
            </p>
          )}
          <H2 color={'black'} value={`URL: ${currentLocation}`}></H2>
        </>
      )}
      <div style={{ display: 'inline-flex' }}>
        <Button
          style={{ marginRight: '2rem' }}
          level={BtnLevel.PRIMARY}
          onClick={() => buttonReturnHandler()}
        >
          Retouner à la page précédente
        </Button>
        {/* <Button onClick={() => resetErrorBoundary()}>Réessayer</Button> */}
      </div>
    </div>
  );
}

export default ErrorBoundary;
